import React from 'react';

export default function CostingsTable() {
	return (
		<div className="table-view table-responsive">
			<table id="costings-table" className="table">
				<thead>
					<tr>
						<th>Order No</th>
						<th>Supplier</th>
						<th>Order Status</th>
						<th>Currency</th>
						<th>Cost</th>
						<th>Tax</th>
						<th>Ex. Rate</th>
						<th>Cost Date</th>
						<th>Reference</th>
						<th>Comments</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
